import { Reveal, SectionLabel } from "@/components/Reveal";

export const About = ({ t }) => (
  <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionLabel testid="about-label">{t.about.label}</SectionLabel>
            <h2 data-testid="about-title" className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] leading-[1.05] mb-8">
              {t.about.title}
            </h2>
            <p data-testid="about-p1" className="text-base sm:text-lg font-light text-slate-600 leading-relaxed">
              {t.about.p1}
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <p data-testid="about-p2" className="text-base sm:text-lg font-light text-slate-500 leading-relaxed mb-10">
              {t.about.p2}
            </p>
            <div className="grid grid-cols-3 gap-6" data-testid="about-stats">
              {t.about.stats.map((s, i) => (
                <div key={i} className="border-t border-[#C5A059]/40 pt-5">
                  <div className="font-display text-4xl sm:text-5xl font-semibold text-[#8C713A]">{s.v}</div>
                  <div className="mt-2 font-mono2 text-[10px] sm:text-xs uppercase tracking-[0.2em] text-slate-500">{s.l}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.15}>
        <div className="relative">
          <div className="absolute -inset-3 border border-[#C5A059]/40 translate-x-4 translate-y-4 hidden sm:block" />
          <img
            src="/assets/team-group.jpg"
            alt="DKT Business Account team"
            data-testid="about-group-photo"
            className="relative w-full aspect-[16/9] object-cover"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
